import React, { StatelessComponent } from 'react';
import { Icon as LegoIcon, IconProps } from 'lego-on-react';

import './icon.css';

const Icon: StatelessComponent<IconProps> = props => (
    <LegoIcon {...props} />
);

export default Icon;
